import styled from 'styled-components/macro';

export const LoaderWrapper = styled.div`
  position: relative;
`;

export const Loader = styled.div`
  position: absolute;
  top: calc(50% - 10px);
  left: -25px;

  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
`;

export const LoaderParts = styled.div`
  position: absolute;

  display: block;
  box-sizing: border-box;
  width: 1rem;
  height: 1rem;
  margin: 2px;
  border: 2px solid #ffffff;
  border-color: #ffffff transparent transparent transparent;
  border-radius: 50%;

  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  :nth-child(1) {
    animation-delay: -0.45s;
  }
  :nth-child(2) {
    animation-delay: -0.3s;
  }
  :nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
